module.exports = __webpack_public_path__ + "img/hongbao-a.b84797a1.jpg";